
<div class="container">
   
    <mat-tab-group class="custom-tab-group">
        <mat-tab  label="PROFILE">
          <form  [formGroup]="ownerForm" >
            <div class="container">
              <div class="row gap-32">
                  <div class="col-md-6 col-xs-12">
                      <div class="row gap-32">
                          <div class="col-md-6 col-xs-12">
                              <mat-form-field appearance="outline" requiered>
                                  <mat-label style="font-size: 16px !important">Owner’s first name</mat-label>
                                  <input matInput  formControlName="firstName" placeholder="Owner’s first name" required />
                                  <mat-error> Owner’s first name is required</mat-error>
                                </mat-form-field>
                          </div>
                          <div class="col-md-6 col-xs-12">
                              <mat-form-field appearance="outline" requiered>
                                  <mat-label style="font-size: 16px !important">Owner’s first name</mat-label>
                                  <input matInput   formControlName="lastName" placeholder="Owner’s last name" required />
                                  <mat-error>Owner’s last name is required</mat-error>
                                </mat-form-field>
                          </div>
                    
                      </div>

                      <div class="row">
                          <mat-form-field appearance="outline" requiered>
                              <mat-label style="font-size: 16px !important">Owner’s email address</mat-label>
                              <input matInput   formControlName="email" placeholder="Owner’s email address" required />
                              <mat-error> Owner’s email address is required</mat-error>
                            </mat-form-field>
                      </div>


                      <div class="row">
                          <mat-form-field appearance="outline" requiered>
                              <mat-label style="font-size: 16px !important">Owner’s phone number</mat-label>
                              <input matInput   formControlName="phoneNumber"  placeholder="Owner’s phone number" required />
                              <mat-error> Owner’s phone number is required</mat-error>
                            </mat-form-field>
                      </div>
                      <div class="row gap-32 flex-direction-xs-col">
                          <mat-radio-group aria-label="Select owner’s address type">
                            <div class="row flex align-item-center gap-10">
                              <div class="col-md-12">
                                <mat-label> Select owner’s address type</mat-label>
                              </div>
                              <div class="col">
                                <mat-radio-button (change)="radioChangeAddress($event)" [checked]="true" color="primary"
                                  value="1">Domestic</mat-radio-button>
                              </div>
                              <div class="col">
                                <mat-radio-button (change)="radioChangeAddress($event)" color="primary" value="2">International</mat-radio-button>
                              </div>
                            </div>
                          </mat-radio-group>
                        </div>
                        <div class="row gap-10">
                          <div *ngIf="addressType == '1'" class="row">
                            <mat-form-field class="full-width" appearance="outline">
                              <mat-label>Owners Street Address</mat-label>
                              <input matInput  formControlName="ownerStreetAddress"  class="form-outline form-control" placeholder="Owners Street Address"
                                 [matAutocomplete]="auto" />
                              <mat-autocomplete #auto="matAutocomplete">
                                <mat-option *ngFor="let suggestion of suggestions" [value]="suggestion.description"
                                  (onSelectionChange)="selectPlace(suggestion)">
                                  {{ suggestion.description }}
                                </mat-option>
                              </mat-autocomplete>
                              <mat-error>Owners Street Address is required</mat-error>
                            </mat-form-field>
                          </div>
                          <div *ngIf="addressType == '2'" class="row">
                            <mat-form-field appearance="outline">
                              <mat-label>Addressee's Full Legal name</mat-label>
                              <input formControlName="addressName" class="form-outline form-control"   matInput
                                placeholder="Addressee's Full Legal name" />
                
                              <mat-error>Addressee's Full Legal name is required</mat-error>
                            </mat-form-field>
                          </div>
                          <div *ngIf="addressType == '1'" class="row">
                            <mat-form-field appearance="outline">
                              <mat-label>Apt/Unit/Suite</mat-label>
                              <input matInput  formControlName="aptUnitSuite"  placeholder="Apt/Unit/Suite" />
                            </mat-form-field>
                          </div>
                          <div *ngIf="addressType == '2'" class="row">
                            <mat-form-field appearance="outline">
                              <mat-label>Street address or post office box number</mat-label>
                              <input formControlName="addressOrPoBox" class="form-outline form-control" matInput
                                placeholder="Street address or post office box number" />
                
                              <mat-error>Street address or post office box number is required</mat-error>
                            </mat-form-field>
                          </div>
                          <div *ngIf="addressType == '1'" class="row gap-10">
                              <div class="col-md-2 col-xs-12">
                              <mat-form-field appearance="outline">
                                <mat-label>City</mat-label>
                                <input matInput formControlName="city"  placeholder="City" />
                                <mat-error>City is required</mat-error>
                              </mat-form-field>
                            </div>
                            <div class="col-md-2 col-xs-12">
                              <mat-form-field appearance="outline">
                                <mat-label>State</mat-label>
                
                                <mat-select  formControlName="state" placeholder="State">
                                  @for (state of states; track state) {
                                  <mat-option [value]="state.id">{{
                                    state.name
                                    }}</mat-option>
                                  }
                                </mat-select>
                
                                <mat-error>State is required</mat-error>
                              </mat-form-field>
                            </div>
                            <div class="col-md-2 col-xs-12">
                              <mat-form-field appearance="outline">
                                <mat-label>Zip Code</mat-label>
                                <input formControlName="zipCode" matInput laceholder="Zip Code" />
                                <mat-error
                                  *ngIf="this.ownerForm.get('zipCode')?.errors?.['pattern'] && (ownerForm.get('zipCode')?.touched)">Zip
                                  Code is invalid</mat-error>
                
                                <mat-error
                                  *ngIf="this.ownerForm.get('zipCode')?.errors?.['required'] && (ownerForm.get('zipCode')?.touched)">Zip
                                  Code is required</mat-error>
                              </mat-form-field>
                            </div>
                          </div>
                          <div *ngIf="addressType == '2'" class="row">
                            <mat-form-field appearance="outline">
                              <mat-label>City, State, Province and Postal Code</mat-label>
                              <input formControlName="cityStateProvince" class="form-outline form-control"   matInput
                                placeholder="City, State, Province and Postal Code" />
                
                              <mat-error>City, State, Province and Postal Code is required</mat-error>
                            </mat-form-field>
                          </div>
                          <div class="row" style="min-height: 56px">
                            <mat-form-field appearance="outline" *ngIf="addressType == '2'">
                              <mat-label>Country</mat-label>
                
                              <mat-select   placeholder="Country">
                                @for (state of country; track state) {
                                <mat-option [value]="state.id">{{ state.name }}</mat-option>
                                }
                              </mat-select>
                              <mat-error>Country is required</mat-error>
                            </mat-form-field>
                          </div>
                     
                    </div>
                  </div>
                  <div class="col-md-6 col-xs-12">
                      <div class="row gap-40">
  
                          <div class="row">
                              <div style="display: flex; align-items: center; gap: 8px;">
                                  <mat-icon class="material-icons-outlined">contact_mail_outline</mat-icon>
                                  <span style="color: rgba(0, 0, 0, 0.87);
                                  font-size: 16px;
                                  font-family: Roboto;
                                  font-weight: 400;
                                  line-height: 24px;
                                  letter-spacing: 0.15px;
                                  word-wrap: break-word">Primary contact info</span>
                                </div>
                          </div>
                          <div class="row gap-32">
                              <div class="col-md-6 col-xs-12">
                                  <mat-form-field appearance="outline" requiered>
                                      <mat-label style="font-size: 16px !important">Primary contact first name</mat-label>
                                      <input matInput  formControlName="primaryContactFirstName" placeholder="Primary contact first name" required />
                                      <mat-error> Primary contact first name is required</mat-error>
                                    </mat-form-field>
                              </div>
                              <div class="col-md-6 col-xs-12">
                                  <mat-form-field appearance="outline" requiered>
                                      <mat-label style="font-size: 16px !important">Primary contact last name</mat-label>
                                      <input matInput formControlName="primaryContactLastName"   placeholder="Primary contact last name" required />
                                      <mat-error>Primary contact last name is required</mat-error>
                                    </mat-form-field>
                              </div>
                        
                          </div>

                          <div class="row gap-32">
                              <div class="col-md-6 col-xs-12">
                                  <mat-form-field appearance="outline" requiered>
                                      <mat-label style="font-size: 16px !important">Primary contact  email address</mat-label>
                                      <input matInput  formControlName="primaryContactEmail"  placeholder="Primary contact  email address" required />
                                      <mat-error>Primary contact  email address is required</mat-error>
                                    </mat-form-field>
                              </div>
                              <div class="col-md-6 col-xs-12">
                                  <mat-form-field appearance="outline" requiered>
                                      <mat-label style="font-size: 16px !important">Primary contact phone number</mat-label>
                                      <input matInput  formControlName="primaryContactPhone"   placeholder="Primary contact phone number" required />
                                      <mat-error>Primary contact phone number is required</mat-error>
                                    </mat-form-field>
                              </div>
                        
                          </div>

                          <div class="row">
                              <mat-form-field appearance="outline">
                                <mat-label>Notes</mat-label>
                                <textarea matInput formControlName="notes"  placeholder="Notes"></textarea>
                              </mat-form-field>
                            </div>

                            <div class="row">
                              <mat-form-field
                              appearance="outline"
                            >
                              <mat-label>Printed Name / eSignature</mat-label>
                              <input 
                                matInput formControlName="printedName"
                                placeholder="Printed Name"
                              />
                              <mat-error>Printed Name is required</mat-error>
                            </mat-form-field>
                            </div>
                      </div>
                  
                  </div>
              </div>
          </div>
          </form>
       
        </mat-tab>

        <mat-tab  label="LICENSES">
          <br />
            <app-entitylicensestep [hidePrimaryContactInfo]="true" [entityLicense]="this.data.entityLicense" [entityRentalPropertyLicense]="this.entityRentalPropertyLicense"></app-entitylicensestep>
  
      </mat-tab>
    </mat-tab-group>
    <div style="width: 100%; background-color: white">
      <div class="button-stepper-footer">
        <button [disabled]="!hasChanges" [ngClass]="{
          'button-stepper-allow':
          hasChanges,
          'button-stepper':
          hasChanges
        }"   mat-stroked-button mat-button (click)="save()"
        class="button-stepper-allow">
        SAVE <mat-icon>save</mat-icon>
      </button>
  
 
  
      </div>
    </div>
</div>